import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Button, Stack, Switch, Typography } from '@mui/material';
import React, { useState } from 'react';
import FieldsHeader from './configurator-common-header';

type FieldData = {
    isVisible: boolean;
    fieldName?: string[];
    [key: string]: any;
  };

const HOAOverviewFields = (props: any) => {
    const { state, keyValue, setState, updateView } = props;
    const [fields, setField] = useState(state)
    const [expanded, setExpanded] = useState<number | false>(0);
    const [searchQuery, setSearchQuery] = useState<string>('');

    const handleAccordionChange = (panel: number) => (event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(event.target.value.toLowerCase());
    };

    const saveData = () => {
        setState((prevState: any) => {
            const newData = { ...prevState };
            newData[keyValue] = Object.fromEntries(
                Object.entries(fields).map(([key, value]: any) => [
                    key,
                    { ...value }
                ])
            );
            return newData;
        });
        updateView("view")
    };

    const handleBack = () => {
        updateView("view")
    }

    const handleCancel = () => {
        setField(state)
    }

    const filterFields = (data: any, query: string) => {
        const result: any = {};
        for (const [key, value] of Object.entries(data)) {
            if (typeof value === 'object' && value !== null) {
                const subResult = filterFields(value, query);
                if (Object.keys(subResult).length > 0 || key.toLowerCase().includes(query)) {
                    result[key] = { ...value, ...subResult };
                }
            } else if (key.toLowerCase().includes(query)) {
                result[key] = value;
            }
        }
        return result;
    };

    const filteredFields = filterFields(fields, searchQuery.trim());

    return (
        <Stack width={"100%"} gap={"16px"} mt={"8px"}>
            <FieldsHeader
                title={keyValue}
                handleSave={saveData}
                handleBack={handleBack}
                handleCancel={handleCancel}
                handleSearchChange={handleSearchChange}
            />
            {Object.entries(filteredFields).map(([key], index) => (
                <FieldAccordion
                    setFields={setField}
                    key={key}
                    title={key}
                    fieldData={filteredFields[key] || {}}
                    setState={setState}
                    handleAccordionChange={handleAccordionChange}
                    expanded={expanded}
                    index={index}
                />
            ))}
        </Stack>
    );
};

export default HOAOverviewFields;

const FieldAccordion = (props: any) => {
    const { title, fieldData, setFields, handleAccordionChange, expanded, index } = props;
    console.log(fieldData)
    
    if (!fieldData) {
        return <Typography>No Data Found</Typography>;
    }

    const toggleVisibilityByKey = (obj: any, targetKey: string): any => {
        const toggleVisibility = (currentObj: any, key: string) => {
            if (currentObj[key] && typeof currentObj[key] === 'object') {
                // Toggle visibility
                currentObj[key].isVisible = !currentObj[key].isVisible;
    
                // If the current object has nested objects, update their visibility based on the current object's visibility
                const isVisible = currentObj[key].isVisible;
                updateNestedVisibility(currentObj[key], isVisible);
            }
        };
    
        const updateNestedVisibility = (obj: any, visibility: boolean) => {
            for (const key in obj) {
                if (typeof obj[key] === 'object' && obj[key] !== null && key !== "fieldName") {
                    if ('isVisible' in obj[key]) {
                        obj[key].isVisible = visibility;
                        updateNestedVisibility(obj[key], visibility);
                    }
                    else{
                        updateNestedVisibility(obj[key], visibility); 
                    }
                }
            }
        };
    
        const traverseAndToggle = (currentObj: any, key: string) => {
            if (currentObj[key]) {
                toggleVisibility(currentObj, key);
            } else {
                for (const k in currentObj) {
                    if (typeof currentObj[k] === 'object' && currentObj[k] !== null && k !== "fieldName" && k !== "isVisible") {
                        traverseAndToggle(currentObj[k], key);
                    }
                }
            }
        };
    
        // Create a deep copy of the object to avoid mutating the original state
        const newData = structuredClone(obj);
    
        traverseAndToggle(newData, targetKey);
    
        // Return the new data
        return newData;
    };
    
    // Usage example in a React component
    const handleToggle = (field: string) => {
        setFields((prevData: any) => {
            let newData={...prevData}
             newData[title] = toggleVisibilityByKey(newData[title], field);
            return newData;
        });
    };

    const countIsVisibleFields = (config: Record<string, FieldData>): { totalCount: number; trueCount: number } => {
        let totalCount = 0;
        let trueCount = 0;
    
        const stack = [config];
    
        while (stack.length > 0) {
            const current = stack.pop();
    
            for (const value of Object.values(current)) {
                if (typeof value === 'object' && value !== null) {
                    if ('isVisible' in value) {
                        totalCount++;
                        if (value.isVisible) {
                            trueCount++;
                        }
                    }
    
                    // Add nested fields to the stack if they exist
                    stack.push(value);
                }
            }
        }
    
        return { totalCount, trueCount };
    };

    const { totalCount, trueCount } = countIsVisibleFields(fieldData);

    const toggleVisibility = (visibility: boolean): any => {

        setFields((prevData: any) => {
            const updateVisibility = (currentObj: any) => {
                for (const key in currentObj) {
                    if (typeof currentObj[key] === 'object' && currentObj[key] !== null) {
                        if ('isVisible' in currentObj[key]) {
                            currentObj[key].isVisible = visibility;
                        }
                        updateVisibility(currentObj[key]);
                    }
                }
                
            };
            
            // Create a deep copy of the object to avoid mutating the original state
            const newData = structuredClone(prevData);
            
            // Update visibility of all fields
            updateVisibility(newData[title]);
            
            return newData;
        });
    };

    const renderFields = (key: any, value: any, fieldIndex: any, totalCount: any, parentKey: any = null,padding=false): any => {
        if (!value.fieldName) {
            return renderSubfield(key, value, fieldIndex, totalCount, parentKey);
        } else {
            return (
                <React.Fragment key={key}>
                    <Stack
                        flexDirection={"row"}
                        pt={"20px"}
                        borderBottom={fieldIndex === totalCount-1? "none":"1px solid #E8E8E8"}
                        justifyContent={"space-between"}
                    >
                        <Typography pl={padding?"16px":"0px"} color={"#3E3E3E"} fontSize={"14px"} fontWeight={500}>{key}</Typography>
                        <Switch
                            sx={{ position: "relative", bottom: "8px" }}
                            checked={value.isVisible}
                            onChange={() =>handleToggle(key)}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />
                    </Stack>
                    <Stack>
                        {value.isVisible && Object.entries(value).map(([nestedKey, nestedValue]: any, nestedFieldIndex: any) => {
                            if(typeof nestedValue === 'object' && (nestedKey !=="fieldName" && nestedKey !== "isVisible")){
                                return renderFields(nestedKey, nestedValue, nestedFieldIndex, totalCount+1, key, true);
                            }
                        })}
                    </Stack>
                </React.Fragment>
            );
        }
    };

    const renderSubfield = (key: any, fieldData: any, fieldIndex: any, totalCount: any, parentKey: any = null) => {
        return (
            <Accordion key={key} defaultExpanded
                onChange={handleAccordionChange(index)}
                disableGutters
                sx={{
                    '&.Mui-expanded': {
                        margin: 0
                    },
                    '&.MuiAccordion-root': {
                        boxShadow: "none",
                        position: "inherit"
                    }
                }}>
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{ borderBottom: "1px solid #E8E8E8", padding: "8px 0px" }}
                >
                    <Typography color={"#3E3E3E"} fontSize={"14px"} fontWeight={500}>{key}</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{
                    '&.MuiAccordionDetails-root': {
                        padding: "0px 0px 4px"
                    }
                }}>
                    <Stack>
                        {Object.entries(fieldData).map(([nestedKey, nestedValue]: any, nestedFieldIndex: any) => {
                            return renderFields(nestedKey,nestedValue,nestedFieldIndex,totalCount,null,true)
                        })}
                    </Stack>
                </AccordionDetails>
            </Accordion>
        );
    };

    return (
        <Accordion defaultExpanded
            onChange={handleAccordionChange(index)}
            disableGutters
            sx={{
                '&.Mui-expanded': {
                    margin: 0
                }
            }}>
            <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="panel1-content"
                id="panel1-header"
            >
                <Typography color={"#303030"} fontSize={"16px"} fontWeight={500}>{title}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                {totalCount > 1 &&
                    <Stack flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"} pb={"16px"}>
                        <Typography fontSize={"12px"} fontWeight={400} color={"#5B5B5B"}>{trueCount}/{totalCount} Data fields enabled</Typography>
                        <Stack flexDirection={"row"} gap={"24px"} fontSize={"12px"} fontWeight={400}>
                            <Button onClick={() => toggleVisibility(true)} variant="text">Show All</Button>
                            <Button onClick={() => toggleVisibility(false)} variant="text">Hide All</Button>
                        </Stack>
                    </Stack>
                }
                <Stack pl={"16px"}>
                {Object.entries(fieldData).map(([key, value]: any, fieldIndex: any) => {
                    return renderFields(key, value, fieldIndex, totalCount);
                })}
                </Stack>
            </AccordionDetails>
        </Accordion>
    );
};

